import { Box, FormControlLabel, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { handleNodeState } from "common/constants/functions";
import { useAppSelector } from "common/hooks";
import _ from "lodash";
import { useEffect, useState } from "react";
import SearchableSelect from "./SearchableSelect";

const Links = ({ nodeState, setNodeState }: any) => {
  const title =
    nodeState?.data?.properties?.title?.ifValue +
    " " +
    nodeState?.data?.properties?.title?.elseValue;

  const [links, setLinks] = useState<any>([]);
  const { nodeToEdit } = useAppSelector((state) => state.nodes);

  const handleLinkChange = ({ target: { name, value } }: any, i: number) => {
    setLinks((prev: any) =>
      prev.map((link: any, index: number) => (index === i ? { ...link, [name]: value } : link))
    );
  };
  useEffect(() => {
    const result = _.reduce(
      links,
      (acc: any, { key, text, linkTo, id, url }) => {
        acc[key] = {
          text,
          [linkTo]: linkTo === "url" ? url : id,
        };
        return acc;
      },
      {}
    );
    handleNodeState(["data", "properties", "title", "links"], result, setNodeState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [links]);
  useEffect(() => {
    const regex = /\{\{([A-Za-z][A-Za-z0-9_]*)\}\}/g;

    const matches: any[] = [];
    let match;

    while ((match = regex.exec(title)) !== null) {
      matches.push(match[1]);
    }

    const updatedState = [
      ...links.filter((s: any) => matches.includes(s.key)), // Keep items that are in newKeys
      ...matches
        .filter((key) => !links.some((s: any) => s.key === key)) // Add new keys
        .map((key) => ({ key, text: "", linkTo: "id", id: "" })), // Convert new keys into objects
    ];

    setLinks(updatedState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);
  useEffect(() => {
    const INITIAL_LINKS = _.map(nodeToEdit?.data?.properties?.title?.links, (value, key) => ({
      key,
      text: value.text,
      linkTo: value.url ? "url" : "id",
      id: value.id || undefined, // Add id if it exists
      url: value.url || undefined, // Add url if it exists
    }));
    setLinks(INITIAL_LINKS);
  }, [nodeToEdit]);
  return links?.length ? (
    <>
      <Typography variant="subtitle2" sx={{ mt: 1 }}>
        Links
      </Typography>
      {links?.map((val: any, i: number) => (
        <Box key={i}>
          <Box>
            <RadioGroup
              row
              name="linkTo"
              value={val.linkTo}
              onChange={(e: any) => handleLinkChange(e, i)}
            >
              <FormControlLabel value="id" control={<Radio />} label="Field ID" />
              <FormControlLabel value="url" control={<Radio />} label="URL" />
            </RadioGroup>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              required
              margin="dense"
              name="key"
              label="Key"
              type="text"
              value={val?.key}
              fullWidth
              disabled
              onChange={(e: any) => handleLinkChange(e, i)}
            />
            <TextField
              required
              margin="dense"
              name="text"
              label="Text"
              type="text"
              value={val.text}
              fullWidth
              onChange={(e: any) => handleLinkChange(e, i)}
            />
            {val.linkTo === "id" ? (
              <SearchableSelect value={val?.id} onChange={(e: any) => handleLinkChange(e, i)} />
            ) : (
              <TextField
                required
                margin="dense"
                name="url"
                label="URL"
                type="text"
                value={val?.url}
                fullWidth
                onChange={(e: any) => handleLinkChange(e, i)}
              />
            )}
          </Box>
        </Box>
      ))}
    </>
  ) : null;
};

export default Links;
